import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ISOQualityPolicyStatement = () => {
  return (
    <div id="iso-quality">
      <Navbar />
      <div className="iso-quality-intro">
        <div className="iso-quality-intro-container">
          <div className="iso-quality-intro-content">
            <h1>
              <span>ISO 90001 </span>OUTCESS QUALITY STATEMENT
            </h1>
          </div>
        </div>
      </div>

      <main>
        <section className="quality-policy-statement">
          <h4>
            <span>OUTCESS </span>QUALITY POLICY STATEMENT
          </h4>
          <p>
            The Board and management of Outcess Solutions Ltd is committed to delivering exceptional 
            customer experiences through our Service Delivery and Call Center / Contact Center operations. 
            We strive to provide the highest level of service, meet customer needs, and exceed their 
            expectations. Our Quality Policy outlines our commitment to quality and continuous improvement 
            in every aspect of our operations.{" "}
          </p>
          <ol>
            <li>
              <span>Achieve and Sustain Customer Satisfaction: </span>We aim to consistently meet and exceed service level 
              agreement (SLA) expectations, by maintaining a customer satisfaction rating of at least 90%.
            </li>

            <li>
              <span>Empower Our Call Agents: </span> We shall enhance product knowledge, communication skills, 
              customer service techniques, and technological proficiency of our Call Agents through a structured 
              periodic training program of no less than 40 hours per agent annually.
            </li>
            <li>
              <span>Develop Our Workforce: </span>
              We are dedicated to achieving a minimum of 80% success in our Staff Training Plan annually, ensuring our 
              employees are equipped with the competencies required to deliver quality services and drive organizational 
              excellence.
            </li>
            <li>
              <span>Ensure Regulatory Compliance: </span>
              We shall uphold at least 98% compliance with all applicable statutory and regulatory requirements, 
              including the Nigeria Data Privacy Act (NDPA), to safeguard customer data and maintain operational 
              integrity.
            </li>

          </ol>
          <p>
            This policy reflects our commitment to quality, accountability, and continuous improvement. 
            It is communicated to all employees and stakeholders and reviewed periodically to ensure its 
            relevance and effectiveness.
          </p>

          <p>
            This Quality Policy applies to all departments, units, staff, processes and procedures of our 
            organization.
          </p>

          <p>
            This Quality Policy shall be:
          </p>
        <ul>
            <li>
                Communicated quarterly and understood by all employees within the organization  
            </li>
            <li>
                Reviewed periodically for continued suitability and relevance   
            </li>
            <li>
                Made available to relevant interested parties
            </li>
        </ul>

        <p>
            This policy shall be reviewed at least once a year or whenever there is a change in the 
            organization’s objectives. It shall be Management’s responsibility to review this policy.
        </p>
          {/* <div className="date-and-signature">
            <div className="signature">
              <img src={signature} alt=""></img>
              <p>IKENNA ODIKE</p>
              <p>CHIEF EXECUTIVE OFFICER</p>
            </div>
            <div className="date">
              <p>____ 23-08-2022 ____</p>
              <p style={{textAlign:"center"}}>DATE</p>
            </div>
          </div> */}
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ISOQualityPolicyStatement;
